module.exports = __webpack_public_path__ + "img/icon-ai-measure-line@3x.e7efbab5.png";